import { TComment } from '../types';
import { compareVersion } from '@modules/items';

/**
 * Returns true if a given comment should be shown at the chosen version
 * (based on the `versionMode` and resolved/unresolved status).
 */

export const showCommentForVersion = (comment: TComment, versionId: string): boolean => {
  // If the comment is specifically pinned to an exact version:
  if (comment.versionMode === 'SPECIFIC') return comment.versionCreated === versionId;

  // Otherwise versionMode === "AUTO":

  // If unresolved => selected version must be >= comment.versionCreated
  if (!comment.resolvedDate) return compareVersion.isGreaterEqualThan(versionId, comment.versionCreated);

  // If resolved => we must also parse the versionResolved
  if (!comment.versionResolved) {
    // Edge case: if "resolvedDate" set but "versionResolved" not set in DB?
    return false;
  }

  // “selected version is >= versionCreated AND <= versionResolved”
  return (
    compareVersion.isGreaterEqualThan(versionId, comment.versionCreated) &&
    compareVersion.isLessEqualThan(versionId, comment.versionResolved)
  );
};
